import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  declarations: [],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  providers: []
})
export class SharedModule {}
